package com.exura.pages

import androidx.compose.runtime.Composable
import com.exura.features.newauth.presentation.HandleSession
import com.exura.navigation.Route
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.rememberPageContext

@Page
@Composable
internal fun Index() {
    val context: PageContext = rememberPageContext()

    HandleSession(
        context = context,
        loggedInDestination = Route.DASHBOARD,
    )
}
